import React from 'react';
import './policy-status-display.scss';
import { VersionLabel, VersionState, VersionStatus } from '../../../utils/enums';
import { versionStatusAndStateMap } from '../../../model/version';
import PolicyStatusLabel from './policy-status-label';

interface PolicyStatusDisplayProps {
  policyNumber: number;
  policyStatus: VersionStatus;
  policyState: VersionState;
}

const PolicyStatusDisplay: React.FC<PolicyStatusDisplayProps> = ({ policyNumber, policyStatus, policyState }) => {

  const generateLabel = (): VersionLabel => {
    const versionLabel = versionStatusAndStateMap.get(policyState, policyStatus)?.label ?? VersionLabel.Inactive;
    return policyState === VersionState.ACTIVE && policyNumber === 1 ? VersionLabel.Initial : versionLabel;
  };

  const label = generateLabel();

  return (
    <PolicyStatusLabel label={label} versionNumber={policyNumber} />
  );
};

export default PolicyStatusDisplay;
